import {
	Fade as FadeMui,
} from '@mui/material';
import { ChildrenProps, appendClassName } from '@componentLibraryWrapper/common';
import './fade.scss';

export interface FadeProps extends ChildrenProps<HTMLElement> {
	children: React.ReactElement<any, any>,
	in?: boolean,
	timeout?: number
}

const Fade = ({
	className,
	//in:fadein,
	timeout=500,
	...rest
}: FadeProps) => {
	return (
		<FadeMui
			{...rest}
			className={appendClassName('sm-fade', className)}
			timeout={timeout}/>
	)
}

export default Fade;